import { Link } from "react-router-dom"

const Projects = () => {
  return (
    <div>
      <h1>Projects</h1>
      <div style={{
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
  }}>
          <div style={{ flex: "0 0 300px", maxWidth: "300px" }}>
              <h3>Archer Mobile Game</h3>
              Features:
              <ul>
                <li>Survival Mode and Target Practice Mode</li>
                <li>Global leaderboard using Firebase</li>
              </ul>
            </div>
            <div
    style={{
      flex: "1 1 300px",
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
    }}
  >
              <img src="/screenshots/archer_screenshot5.png" alt="Screenshot 5" style={{ 
    width: "48%", 
    aspectRatio: "16/9", 
    objectFit: "cover",
    borderRadius: "8px" 
  }}  />
              <img src="/screenshots/archer_screenshot_wavetext.png" alt="Screenshot 2" style={{ 
    width: "48%", 
    aspectRatio: "16/9", 
    objectFit: "cover",
    borderRadius: "8px" 
  }}  />
              <img src="/screenshots/archer_screenshot_flamingarrow.png" alt="Screenshot 6" style={{ 
    width: "48%", 
    aspectRatio: "16/9", 
    objectFit: "cover",
    borderRadius: "8px" 
  }}  />
              <img src="/screenshots/archer_screenshot4.png" alt="Screenshot 4" style={{ 
    width: "48%", 
    aspectRatio: "16/9", 
    objectFit: "cover",
    borderRadius: "8px" 
  }}  />
  <img src="/screenshots/archer_screenshot_targetpractice.png" alt="Screenshot 5" style={{ 
    width: "48%", 
    aspectRatio: "16/9", 
    objectFit: "cover",
    borderRadius: "8px"
  }}  />
              <img src="/screenshots/archer_screenshot1.png" alt="Screenshot 5" style={{ 
    width: "48%", 
    aspectRatio: "16/9", 
    objectFit: "cover",
    borderRadius: "8px"
  }}  />              
            </div>
          </div>
      <ul style={{ listStyleType: "none", paddingLeft: "0",maxWidth: "800px" }}>
        <li>
          <h3>Network Performace Tracker</h3>
        </li>
        <p>
          This was a data science project I made as part of my A level in
          Computer Science. It was a tool that could be used by network
          operators such as Vodafone and EE to detect faults and areas of low
          performance in their network by utilising social media. I still
          consider this to be the most difficult project I have ever made, but I
          gained so many new skills such as using Pandas, databases, displaying
          data, and working with APIs, and it sparked my interest in data
          science which I will look to do more of in the future.{" "}
          <Link to={"/projects/nea"}>more</Link>
        </p>
        <img
          src="screenshots/Screenshot 2021-04-10 at 15.01.36.png"
          width="600px"
          alt="network performance tracker"
        />
        <li>
          <h3>Role-based CRUD App</h3>
          <p>
            This is a role-based CRUD backend API using express js to store
            users in a MongoDB database. Use Postman to send requests. Users can
            register a new account, then login and view data, and logout. Admins
            and mods can view and change users (but only admins can change
            users' roles). The project uses access tokens and refresh tokens for
            user authentication.{" "}
            <a href="https://github.com/GeorgeCGarman/users-backend-repo.git">
              view on Github
            </a>
          </p>
        </li>
        <li>
          <h3>User-microservice</h3>
          <p>
            An API for user profiles. Users can also raise complaints about the
            service and give ratings to other users.{" "}
            <a href="https://github.com/GeorgeCGarman/user-microservice">
              view on Github
            </a>
          </p>
        </li>
        <li>
          <h3>Community Forum</h3>
          <p>
            This app has a React frontend and a Node.js backend. The Node.js
            backend contains functionality for CRUD operations on users,
            questions, comments and upvotes. The frontend contains functionality
            for viewing questions and comments, but doesn't yet give you the
            ability to add questions or upvote them, and authentication has not
            yet been added.{" "}
            <a href="https://github.com/GeorgeCGarman/community-forum-frontend">
              view on Github
            </a>
          </p>
        </li>

        <li>
          <h3>Through the Gaps</h3>
          <img
            src="screenshots/Screenshot 2022-10-19 at 15.56.26.png"
            width="800px" alt="app-img"
          />
          <p>
            A game I got in the iOS App Store aged 12{" "}
            <a href="https://apps.apple.com/gb/app/through-the-gaps/id1036169178">
              view on App Store
            </a>
          </p>
        </li>
      </ul>
    </div>
  )
}

export default Projects
